import React, { useState, useEffect } from 'react'
import { DataPersonalEmpleado, CurriculumEmpleado } from "./parts"
import { Box, Container, Paper, Tab, Tabs, Stack, Grid } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { BreadcrumbsList, MoveButtons } from 'components/data_display'
import { COLOR } from 'theme/Colors.js'
import { Button } from 'components/forms/components';
import { Text } from 'components/texts/index.js'
import { TabPanel } from 'components/modifications/mui/TabPanel/index.jsx'
import { Edit as EditIcon } from '@mui/icons-material'
import { TabContext } from '@mui/lab'
import { enqueueSnackbar } from 'notistack'
import Requests from './Requests/Requests.js'
import SkeletonDatosEmpleado from 'components/forms/display/ficha-empleado/DataForm/DatosPersonalesDataForm/skeleton'
import { ListadosDataForm, DatosContratosForm, PagosDataForm, AsistenciaYextras } from "components/forms/display";

/**
 * Formulario formulario del empleado
 * 
 */
export default function SingleFichaEmpleado() {

    //HOOKS
    const [tab, setTab] = useState("1")
    const [empleado, setEmpleado] = useState()
    const navigate = useNavigate()
    const navigationParams = useParams()

    const [id_empleado, setIdEmpleado] = useState(navigationParams?.id_empleado)

    const getEmpleado = () => {
        new Requests().getEmpleado(id_empleado, (empleado) => {
            setEmpleado(empleado)
            updateId(id_empleado)
        }, () => enqueueSnackbar(<Text>No se ha podido obtener el empleado.</Text>, { variant: "error" }))
    }

    useEffect(() => {
        getEmpleado();
    }, [id_empleado]);

    const updateId = (id) => {
        navigate(`../ficha-empleados/${id}`);
        setIdEmpleado(id);
    }

    return (
        <Grid container p={3}>
            <Container maxWidth={false} sx={{ mt: 5 }}>
                <Stack direction="row" justifyContent={"space-between"} marginX={8}>
                    <BreadcrumbsList mx={0} breadcrumbsList={[
                        { to: "/", label: "Inicio" },
                        { to: "./../", label: "Empleados" },
                        { to: "./", label: "Ficha Empleado #" + (id_empleado ?? "0000"), actualItem: true },
                    ]} />

                    <MoveButtons
                        actualItemId={id_empleado}
                        beforeFetchCallback={() => setEmpleado(null)}
                        onUpdateActualItem={updateId} />
                </Stack>

                <Paper elevation={2} sx={{ m: 2, mx: 8, my: 2, pb: 5 }}>
                    <Grid container display={"flex"} justifyContent={"end"} alignItems={"start"}>
                        <Grid item xs={2} sx={{ marginTop: 3 }}>
                            <Button variant={"outlined"} startIcon={<EditIcon />} onClick={() => { navigate('./editar') }}>
                                Editar
                            </Button>
                        </Grid>
                    </Grid>

                    <TabContext value={tab}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mx={2}>
                            <Tabs value={tab} onChange={(e, tab) => { setTab(tab) }} TabIndicatorProps={{ style: { backgroundColor: COLOR.standard.main } }}>
                                <Tab label={<Text fontWeight={tab === "1" ? "bold" : null} color={tab === "1" ? COLOR.standard.main : null}>DATOS PERSONALES</Text>} value={"1"} />
                                <Tab label={<Text fontWeight={tab === "2" ? "bold" : null} color={tab === "2" ? COLOR.standard.main : null}>CURRICULUM VITAE</Text>} value={"2"} />
                                <Tab label={<Text fontWeight={tab === "3" ? "bold" : null} color={tab === "3" ? COLOR.standard.main : null}>LISTADOS</Text>} value={"3"} />
                                <Tab label={<Text fontWeight={tab === "4" ? "bold" : null} color={tab === "4" ? COLOR.standard.main : null}>DATOS CONTRATOS</Text>} value={"4"} />
                                <Tab label={<Text fontWeight={tab === "5" ? "bold" : null} color={tab === "5" ? COLOR.standard.main : null}>DATOS CONTRATOS</Text>} value={"5"} />
                            </Tabs>
                        </Box>

                        <TabPanel value={"1"}>
                            {empleado ? <DataPersonalEmpleado empleado={empleado} />
                                : <SkeletonDatosEmpleado />}
                        </TabPanel>

                        <TabPanel value={"2"}>
                            {empleado ? <CurriculumEmpleado isSingle={true} empleado={empleado} /> : <SkeletonDatosEmpleado />}
                        </TabPanel>

                        <TabPanel value={"3"}>
                            <ListadosDataForm isSingle={true}/>
                        </TabPanel>

                        <TabPanel value={"4"}>
                            <DatosContratosForm isSingle={true} />
                        </TabPanel>

                    </TabContext>
                </Paper>
            </Container>

        </Grid>
    )
}